import { render, staticRenderFns } from "./buyChangHome.vue?vue&type=template&id=4949446a&"
import script from "./buyChangHome.vue?vue&type=script&lang=js&"
export * from "./buyChangHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports